import React, { useContext } from 'react';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';
import CloseIcon from '@material-ui/icons/Close';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { Button, Checkbox, FormControlLabel, MenuItem, Select, Typography } from '@material-ui/core';

import { SortableItemContext } from '../ContentItem';
import { playlistDisplayTypes, playlistTitleTypes } from '../../../../../../constants/portalThemesConstant';

type PlaylistContentProps = {
	item: any;
};
const PlaylistContent = ({ item }: PlaylistContentProps) => {
	const { id, playlistId, displayType, rows, isShowTitle, showTitleType } = item;
	const {
		attributes,
		listeners,
		ref,
		playlists,
		expandedId,
		accountPreset,
		handleUpdatePlaylist,
		handleDeleteContentItem,
		handleDuplicateContentItem,
		setExpandedId,
	} = useContext(SortableItemContext);

	const isExpand = expandedId === id;

	const selectedPlaylist = playlists.find((playlist) => playlist.id === playlistId);

	return (
		<>
			<div
				{...attributes}
				{...listeners}
				ref={ref}
				style={{
					border: '1px solid #909CA5',
					borderTopLeftRadius: 4,
					borderTopRightRadius: 4,
					borderBottomLeftRadius: isExpand ? 0 : 4,
					borderBottomRightRadius: isExpand ? 0 : 4,
					cursor: 'pointer',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
				onClick={() => {
					setExpandedId(expandedId === id ? '' : id);
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'start',
						alignItems: 'center',
						gap: 10,
						padding: '14px 0 14px 10px',
					}}
				>
					<PlaylistPlayIcon />
					<Typography variant="body1">
						{selectedPlaylist?.metadata?.title ? selectedPlaylist?.metadata?.title : 'Playlist'}
					</Typography>
				</div>
				<div style={{ display: 'flex' }}>
					<Button
						style={{ minWidth: 0, padding: '14px 10px', borderRadius: 0, borderLeft: '1px solid #909CA5' }}
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							handleDuplicateContentItem(id);
						}}
					>
						<FileCopyIcon fontSize="small" />
					</Button>
					<Button
						style={{ minWidth: 0, padding: '14px 10px', borderRadius: 0, borderLeft: '1px solid #909CA5' }}
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							handleDeleteContentItem(id);
						}}
					>
						<CloseIcon fontSize="small" />
					</Button>
				</div>
			</div>
			{isExpand && (
				<div
					style={{
						borderLeft: '1px solid #909CA5',
						borderRight: '1px solid #909CA5',
						borderBottom: '1px solid #909CA5',
						borderTopLeftRadius: 0,
						borderTopRightRadius: 0,
						borderBottomLeftRadius: 4,
						borderBottomRightRadius: 4,
						padding: '14px 10px',
					}}
				>
					<FormControlLabel
						className={'inspect-media__input--full'}
						style={{ display: 'flex' }}
						control={
							<Select
								value={playlistId}
								variant="outlined"
								style={{ width: '50px' }}
								onChange={(
									event: React.ChangeEvent<{
										name?: string;
										value: unknown;
									}>
								) => {
									const value = event.target.value as string;
									handleUpdatePlaylist(id, 'playlistId', value);
								}}
							>
								{playlists.map(({ id, metadata }: any) => {
									const name = metadata?.title ?? 'No title';
									return (
										<MenuItem key={id} value={id}>
											{name.length > 60 ? `${name.substring(0, 60)}...` : name}
										</MenuItem>
									);
								})}
							</Select>
						}
						label={
							<span className={'inspect-media__input-label'}>
								<Typography variant="body1">Name of playlist</Typography>
							</span>
						}
						labelPlacement={'start'}
					/>
					<FormControlLabel
						className={'inspect-media__input--full'}
						style={{ display: 'flex' }}
						control={
							<Select
								value={displayType}
								variant="outlined"
								fullWidth
								onChange={(
									event: React.ChangeEvent<{
										name?: string;
										value: unknown;
									}>
								) => {
									const value = event.target.value as string;
									handleUpdatePlaylist(id, 'displayType', value);
									if (value === 'carousel') {
										handleUpdatePlaylist(id, 'rows', 1);
									}
									if (value === 'grid') {
										handleUpdatePlaylist(id, 'showTitleType', 'normal');
									}

									if (value === 'storyCarousel') {
										handleUpdatePlaylist(id, 'showTitleType', 'normal');
										handleUpdatePlaylist(id, 'rows', 1);
									}
								}}
							>
								{playlistDisplayTypes.map(({ key, label }: any) => {
									if (key === 'storyCarousel' && !(accountPreset ?? []).includes('Story')) {
										return;
									}
									return (
										<MenuItem key={key} value={key}>
											{label}
										</MenuItem>
									);
								})}
							</Select>
						}
						label={
							<span className={'inspect-media__input-label'}>
								<Typography variant="body1">Display</Typography>
							</span>
						}
						labelPlacement={'start'}
					/>

					<FormControlLabel
						className={'inspect-media__input--full'}
						style={{ display: 'flex' }}
						control={
							<Select
								value={rows}
								variant="outlined"
								fullWidth
								disabled={displayType === 'carousel' || displayType === 'storyCarousel'}
								onChange={(
									event: React.ChangeEvent<{
										name?: string;
										value: unknown;
									}>
								) => {
									const value = event.target.value as string;
									handleUpdatePlaylist(id, 'rows', value);
								}}
							>
								{[1, 2, 3, 4, 5].map((value: number) => {
									return (
										<MenuItem key={value} value={value}>
											{value}
										</MenuItem>
									);
								})}
							</Select>
						}
						label={
							<span className={'inspect-media__input-label'}>
								<Typography variant="body1">Rows</Typography>
							</span>
						}
						labelPlacement={'start'}
					/>

					<FormControlLabel
						className={'inspect-media__input--full'}
						style={{ display: 'flex' }}
						control={
							<Select
								value={showTitleType}
								variant="outlined"
								fullWidth
								disabled={displayType === 'grid' || displayType === 'storyCarousel'}
								onChange={(
									event: React.ChangeEvent<{
										name?: string;
										value: unknown;
									}>
								) => {
									const value = event.target.value as string;
									handleUpdatePlaylist(id, 'showTitleType', value);
								}}
							>
								{playlistTitleTypes.map(({ key, label }: any) => {
									return (
										<MenuItem key={key} value={key}>
											{label}
										</MenuItem>
									);
								})}
							</Select>
						}
						label={
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<Checkbox
									id={`${id}-showTitle`}
									color="primary"
									checked={isShowTitle}
									size="small"
									onChange={(_, checked) => {
										handleUpdatePlaylist(id, 'isShowTitle', checked);
									}}
								/>
								<label
									htmlFor={`${id}-showTitle`}
									style={{ color: 'rgba(0, 0, 0, 0.87)', fontWeight: '400' }}
								>
									Show title
								</label>
							</div>
						}
						labelPlacement={'start'}
					/>
				</div>
			)}
		</>
	);
};

export default PlaylistContent;
